"use client";

import { useEffect } from "react";

import { useAnalytics } from "@context/analytics-context";
import { mapProductToItem } from "@lib/analytics/mappers";

export default function ProductAnalyticsTracker({ product }: { product: any }) {
  const analytics = useAnalytics();

  useEffect(() => {
    if (!analytics.ready || !product) {
      return;
    }
    const { item, currency, unitPrice } = mapProductToItem(product);
    analytics.trackViewItem({
      items: [item],
      currency,
      value: typeof unitPrice === "number" ? unitPrice : undefined,
    });
  }, [analytics, product]);

  return null;
}
